// import React, { useEffect } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Grid,
//   Box
// } from '@mui/material';
// import { useForm } from 'react-hook-form';
// import FormInput from '../../../../components/FormFields/FormFields';
// import PageButton from '../../../../components/PageButton/index';
// import { useTranslation } from 'react-i18next';
// import PageTypography from 'src/components/PageTypography/PageTypography';


// interface SpecializationsFormProps {
//   open: boolean;
//   title: string;
//   initialValues?: any;
//   onClose: () => void;
//   onSubmit: (data: any) => void;
//   loading: boolean;
//   subId?: string | number;
// }

// const AddSubSpecializationsForm: React.FC<SpecializationsFormProps> = ({
//   open,
//   title,
//   initialValues,
//   onClose,
//   onSubmit,
//   loading = false,
//   subId
// }) => {
//   const { t } = useTranslation();
//   const preview = false
//   const {
//     handleSubmit,
//     reset,
//     control,
//     formState: { errors }
//   } = useForm({
//     defaultValues: initialValues || {
//       name_en: '',
//       name_ar: '',
//       description_en: '',
//       description_ar: '',
//       specialization: subId || '',
//       is_active: true
//     }
//   });

//   useEffect(() => {
//     reset(initialValues);
//   }, [initialValues, reset]);

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
//       <DialogTitle>{title}</DialogTitle>

//       <form onSubmit={handleSubmit(onSubmit)}>
//         <DialogContent dividers>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <FormInput
//                 name="name_en"
//                 fullWidth
//                 control={control}
//                 label={t('englishName')}
//                 rules={{ required: t('Name is Required') }}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <FormInput
//                 name="name_ar"
//                 fullWidth
//                 label={t('arbicName')}
//                 rules={{ required: t('This Field is Required') }}
//                 control={control}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <FormInput
//                 name="description_en"
//                 fullWidth
//                 multiline
//                 rows={3}
//                 label={t('descriptionEnglish')}
//                 rules={{ required: t('Description is Required') }}
//                 control={control}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <FormInput
//                 name="description_ar"
//                 fullWidth
//                 multiline
//                 rows={3}
//                 label={t('descriptionArbic')}
//                 rules={{ required: t('Description is Required') }}
//                 control={control}
//               />
//             </Grid>
//           </Grid>

// {
//   !subId && (
// <Box
//                       component="label"
//                       sx={{
//                         border: '2px dashed #ccc',
//                         borderRadius: 1,
//                         height: 100,
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         cursor: 'pointer',
//                         overflow: 'hidden',
//                         marginTop: 2,
//                       }}
//                     >
//                       {preview ? (
//                         <img
//                           src={""}
//                           alt="Banner"
//                           style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//                         />
//                       ) : (
//                         <PageTypography color="text.secondary">
//                           {t('SPECIALIZATIONSIcon')}
//                         </PageTypography>
//                       )}
//                       <input
//                         hidden
//                         type="file"
//                         accept="image/*"
//                         // onChange={(e) =>
//                         //   e.target.files && handleImageChange(e.target.files[0])
//                         // }
//                       />
//                     </Box>
//   )
// }
            
//         </DialogContent>

//         <DialogActions
//           sx={{
//             px: 0,
//             pt: 3,
//             display: 'flex',
//             justifyContent: 'flex-end',
//             marginRight:"5px"
//           }}
//         >
//           <PageButton
//             onClick={onClose}
//             variant="outlined"
//             sx={{ marginInlineEnd: 1 }}
//           >
//             {t('Cancel')}
//           </PageButton>

//           <PageButton
//             loading={loading}
//             type="submit"
//             variant="contained"
//             color="primary"
//           >
//             {t('Save')}
//           </PageButton>
//         </DialogActions>
//       </form>
//     </Dialog>
//   );
// };

// export default AddSubSpecializationsForm;


import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid
} from '@mui/material';
import { useForm } from 'react-hook-form';
import FormInput from '../../../../components/FormFields/FormFields';
import PageButton from '../../../../components/PageButton/index';
import { useTranslation } from 'react-i18next';
import { SubSpecializationsFormValues, SubSpecializationsPayload } from 'src/reduxServer/services/specializations/types';

interface SubSpecializationsFormProps {
  open: boolean;
  title: string;
  initialValues?: SubSpecializationsPayload;
  onClose: () => void;
  onSubmit: (data: SubSpecializationsPayload) => void;
  loading: boolean;
  subId?: string | number; // parent specialization id, required for creation
  message?: string; // optional message field
}

const defaultValues: SubSpecializationsPayload = {
  name_en: '',
  name_ar: '',
  description_en: '',
  description_ar: '',
  specialization: 0, // default to 0, will be overridden by subId if provided
  is_active: true
};

const AddSubSpecializationsForm: React.FC<SubSpecializationsFormProps> = ({
  open,
  title,
  initialValues,
  onClose,
  onSubmit,
  loading = false,
  subId
}) => {
  const { t } = useTranslation();

  const {
    handleSubmit,
    reset,
    control
  } = useForm<SubSpecializationsFormValues>({
    defaultValues: initialValues || { ...defaultValues, specialization: subId || '' }
  });

  useEffect(() => {
    reset(initialValues || { ...defaultValues, specialization: subId || '' });
  }, [initialValues, subId, reset]);

  const handleFormSubmit = (data: SubSpecializationsFormValues) => {
    onSubmit({
      ...data,
      specialization: Number(subId ?? data.specialization) // ensure number, matches payload
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{title}</DialogTitle>

      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormInput
                name="name_en"
                fullWidth
                control={control}
                label={t('englishName')}
                rules={{ required: t('Name is Required') }}
              />
            </Grid>

            <Grid item xs={12}>
              <FormInput
                name="name_ar"
                fullWidth
                label={t('arbicName')}
                rules={{ required: t('This Field is Required') }}
                control={control}
              />
            </Grid>

            <Grid item xs={12}>
              <FormInput
                name="description_en"
                fullWidth
                multiline
                rows={3}
                label={t('descriptionEnglish')}
                rules={""}
                control={control}
              />
            </Grid>

            <Grid item xs={12}>
              <FormInput
                name="description_ar"
                fullWidth
                multiline
                rows={3}
                label={t('descriptionArbic')}
                rules={""}
                control={control}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions
          sx={{
            px: 0,
            pt: 3,
            display: 'flex',
            justifyContent: 'flex-end',
            marginRight: '5px'
          }}
        >
          <PageButton
            onClick={onClose}
            variant="outlined"
            sx={{ marginInlineEnd: 1 }}
          >
            {t('Cancel')}
          </PageButton>

          <PageButton
            loading={loading}
            type="submit"
            variant="contained"
            color="primary"
          >
            {t('Save')}
          </PageButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddSubSpecializationsForm;